module.exports = "//public.getcloudapp.com/packs/media/images/icon-padlock-756a2a828c34f7f4761b60483053d698.svg";